module.exports = "0xd4AEF35E4F0Cab91E06b5b152251CBfEcf42072b"


// WEBPACK FOOTER //
// ./src/contracts/PizzaParlor.3.address.js